export default __webpack_public_path__ + "static/media/550.829cae9f.png";